export function checkPermissions(userPermissions, verifyPermissions) {
  /** Allow access if the user has any of the passed in permissions. */
  return userPermissions.some((permission) =>
    verifyPermissions.includes(permission.code)
  );
}
